import {sendGetRequest, sendPutRequest} from '../../requests';

export enum AlertType {
  PROCESS_ALERT = 'PROCESS_ALERT',
  TASK_ALERT = 'TASK_ALERT'
}

export enum ProcessType {
  SCHEDULING = 'SCHEDULING',
  CHECK_IN = 'CHECK_IN',
  CLINICAL_EVALUATION = 'CLINICAL_EVALUATION',
  TREATMENT_CARE = 'TREATMENT_CARE',
  CHECKOUT = 'CHECKOUT',
  INVESTIGATE = 'INVESTIGATE'
}

const baseUrl = '/settings/alert-alarm';

export const getAllAlertSettings = (type: string) =>
  sendGetRequest(`${baseUrl}/${type}`);

export const getAlertSettingsByProcessType = (processType: string) =>
  sendGetRequest(`${baseUrl}/${AlertType.PROCESS_ALERT}/process-types/${processType}`);

export const getTaskAlertSettingsByProcessType = (processType: string) =>
  sendGetRequest(`${baseUrl}/${AlertType.TASK_ALERT}/process-types/${processType}`);

export const updateAllAlertSettings = (type: string, isRelative: boolean) =>
  sendPutRequest(`${baseUrl}/${type}?relative=${isRelative}`);

export const updateAlertSetting = (
    type: string,
    processType: string,
    range: number
) =>
  sendPutRequest(
      `${baseUrl}/${type}/process-types/${processType}?range=${range}`
  );
